export type CategoryForm = {
  name: string;
  display_order: string;
};

export const emptyCategoryForm = (): CategoryForm => ({
  name: '',
  display_order: '',
});

export const parseCategoryForm = (
  form: CategoryForm
): {
  name: string;
  display_order: number;
} | null => {
  if (!form.name.trim()) {
    alert('カテゴリ名を入力してください。');
    return null;
  }

  const displayOrderValue = form.display_order.trim();
  const parsedDisplayOrder = displayOrderValue === '' ? NaN : Number(displayOrderValue);
  if (displayOrderValue === '' || Number.isNaN(parsedDisplayOrder)) {
    alert('表示順は数字で入力してください。');
    return null;
  }

  return {
    name: form.name.trim(),
    display_order: parsedDisplayOrder,
  };
};
